import { Translation } from '../i18n-types';

const de: Translation = {};
export default de;
